export default {
  INIT_MODAL: 'ModalConstants,INIT_MODAL',
  TOGGLE_MODAL: 'ModalConstants.TOGGLE_MODAL',
};
